/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SupportModule
 */

// TODO: Remove Support module once the Tech Support v3 is migrated
import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    HttpWrapper,
    HTTP_WRAPPER_TOKEN,
} from 'ajs/modules/core/factories/http-wrapper/http-wrapper.service';

const supportModule = angular.module('avi/support');

const factories = [
    {
        factory: HttpWrapper,
        name: HTTP_WRAPPER_TOKEN,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(supportModule, 'factory', name, factory);
});
